import { NgModule } from '@angular/core';
import { Highlight } from './highlight';

@NgModule({
  imports: [Highlight],
  exports: [Highlight]
})
export class HighlightModule {
}
